export const enum MainLoginState {
  ENTER_YOUR_EMAIL,
  LOGIN_METHOD_SELECTION,
}
